import { splitLicensePlateForApi } from '../../../shared/utils/split-license-plate-for-api';

/** Normalize plate to the plate-only segment for equality checks (state prefix stripped when present). */
export function normalizeOrderRequestPlateForCompare(
  raw: string,
  stateHint?: string | null
): string {
  const trimmed = String(raw ?? '')
    .trim()
    .replace(/\s+/g, '')
    .toUpperCase();
  if (!trimmed) {
    return '';
  }
  const parsed = splitLicensePlateForApi(trimmed, stateHint);
  return (parsed.license_plate || trimmed).trim().toUpperCase();
}

/** True when form plate matches a linked vehicle plate (with optional state). */
export function orderRequestPlatesMatch(
  formPlate: string,
  vehiclePlate: string,
  vehicleState?: string | null,
  stateHint?: string | null
): boolean {
  const formKey = normalizeOrderRequestPlateForCompare(formPlate, stateHint);
  if (!formKey) {
    return false;
  }
  const plate = String(vehiclePlate ?? '').trim();
  if (!plate) {
    return false;
  }
  const state = String(vehicleState ?? '').trim();
  const candidates = [
    normalizeOrderRequestPlateForCompare(plate, state || stateHint),
    normalizeOrderRequestPlateForCompare(state ? `${state}${plate}` : plate, stateHint),
  ].filter(Boolean);
  return candidates.some(c => c === formKey);
}

/** Check form plate against GET vehicle/memberships/phone payload vehicles. */
export function isFormPlateInMembershipsPhonePayload(
  formPlate: string,
  payload:
    | {
        vehicles?: ({ vehicle?: { license_plate?: string; state?: string } | null } | null)[];
      }
    | null
    | undefined,
  stateHint?: string | null
): boolean {
  const vehicles = payload?.vehicles ?? [];
  return vehicles.some(entry =>
    orderRequestPlatesMatch(
      formPlate,
      String(entry?.vehicle?.license_plate ?? ''),
      entry?.vehicle?.state,
      stateHint
    )
  );
}

/** Check form plate against GET vehicle/list/{customerId} rows. */
export function isFormPlateInCustomerVehicleRows(
  formPlate: string,
  rows:
    | {
        license_plate?: string;
        licensePlate?: string;
        state?: string;
      }[]
    | null
    | undefined,
  stateHint?: string | null
): boolean {
  if (!Array.isArray(rows) || rows.length === 0) {
    return false;
  }
  return rows.some(row =>
    orderRequestPlatesMatch(
      formPlate,
      String(row?.license_plate || row?.licensePlate || ''),
      row?.state,
      stateHint
    )
  );
}
